/* eslint-disable react/require-default-props */
import React, { useRef, useState, useCallback, useEffect, useMemo } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { translate } from '@utils/i18n';
import useNotesMutations from '../hooks/useNotesMutations';
const namespace = 'features.activity_feed.visibility_toggle';
export default function VisibilityToggle({ note, onVisibilityChange }) {
    const anchor = useRef(null);
    const popup = useRef(null);
    const [open, setOpen] = useState(false);
    const { updateNote } = useNotesMutations({
        buildingId: note.buildingId,
        inspectionId: note.inspectionId,
        workOrderId: note.workOrderId
    });
    const handleBodyClick = useCallback((event) => {
        var _a, _b, _c;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,, no-underscore-dangle
        if ((_b = (_a = popup.current) === null || _a === void 0 ? void 0 : _a._popup) === null || _b === void 0 ? void 0 : _b.contains(event.target))
            return;
        if ((_c = anchor.current) === null || _c === void 0 ? void 0 : _c.contains(event.target))
            return;
        setOpen(false);
    }, []);
    useEffect(() => {
        document.body.addEventListener('click', handleBodyClick);
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);
    const changeVisibility = (newVisibility) => {
        return () => {
            if (onVisibilityChange)
                return onVisibilityChange(newVisibility);
            void updateNote({
                id: note.id,
                buildingId: note.buildingId,
                note: { notes: note.notes, visibility: newVisibility }
            });
            setOpen(false);
        };
    };
    const onButtonClick = () => {
        if (note.canEditVisibilityDestroy)
            setOpen(!open);
    };
    const buttonClass = useMemo(() => (onVisibilityChange ? 'qmb-control--sm' : 'qmb-control--icon--sm--dim'), []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Popup, { anchor: anchor.current, show: open, ref: popup },
            React.createElement("div", { className: "qmb-popup--actions" },
                React.createElement("div", { className: "popup__section--group--y-fill" },
                    React.createElement("h4", { className: "popup__title--group" }, translate('title', { namespace })),
                    React.createElement("ul", { role: "presentation" },
                        React.createElement("li", null,
                            React.createElement("label", { className: "qmb-radio" },
                                React.createElement("input", { type: "radio", checked: note.visibility === 'tech', onChange: changeVisibility('tech') }),
                                React.createElement("i", { className: "fa-light fa-light fa-user-helmet-safety" }),
                                translate('tech', { namespace }))),
                        React.createElement("li", null,
                            React.createElement("label", { className: "qmb-radio" },
                                React.createElement("input", { type: "radio", checked: note.visibility === 'user', onChange: changeVisibility('user') }),
                                React.createElement("i", { className: "fa-light fa-phone-office" }),
                                translate('user', { namespace }))))))),
        React.createElement("button", { type: "button", className: buttonClass, ref: anchor, onClick: onButtonClick },
            note.visibility === 'tech' && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "fa-light fa-user-helmet-safety" }),
                onVisibilityChange && translate('tech', { namespace }))),
            note.visibility === 'user' && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "fa-light fa-phone-office" }),
                onVisibilityChange && translate('user', { namespace }))),
            note.visibility === 'customer' && React.createElement("i", { className: "fa-light fa-users" }))));
}
